import React, { Component } from 'react'
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css'
import 'react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css'
import 'react-bootstrap-table2-filter/dist/react-bootstrap-table2-filter.min.css'
import BootstrapTable from 'react-bootstrap-table-next'
import Heading from './Heading'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import filterFactory from 'react-bootstrap-table2-filter'

class Table extends Component {
	constructor(props) {
		super(props)
		this.state = {
			enableFilters: false
		}
	}

	toggleFilters = () => {
		const { enableFilters } = this.state
		this.setState({
			enableFilters: !enableFilters
		})
	}

	render() {
		const { enableFilters } = this.state
		const { title, keyField = 'id', data, columns, expandRow, search = false, paginationSettings, classes = '', headerClasses, rowClasses = '', rowEvents, showFilterBtn } = this.props
		const { SearchBar } = Search
		const pagination = paginationFactory({
			sizePerPageList: [{
				text: '5', value: 5
			}, {
				text: '10', value: 10
			}, {
				text: '15', value: 15
			}, {
				text: '20', value: 20
			}],
			...paginationSettings
		})

		return <div className='u-relative'>
			{ showFilterBtn && <div className={`c-table__filter${enableFilters ? ' c-table__filter--enabled' : ''}`} onClick={this.toggleFilters}></div>}
			< ToolkitProvider
				// By default key field is `id`
				keyField={keyField}
				// Array of data objects
				data={data}
				// Array of column objects
				columns={columns.map(column =>({
					...column,
					filter: enableFilters ? column.filter : null
				}))}
				// Should search be shown
				search={search}
			>
				{
					props => <div className='o-layout u-text--normal'>
						{ title && <Heading text={title} classes='u-text--large o-layout__item u-1/1 u-2/3@desktop u-1/2@tablet' />}
						{ search && <div className='o-layout__item u-1/1 u-1/3@desktop u-1/2@tablet u-text--right'><SearchBar className='c-search' {...props.searchProps} /></div> }
						<BootstrapTable
							expandRow={expandRow}
							wrapperClasses='o-layout__item u-1/1'
							// Table classes
							classes={`c-table ${classes}`}
							// Header classes
							headerClasses={headerClasses}
							// Row classes
							rowClasses={`c-table__row ${rowClasses}`}
							// Pagination
							pagination={paginationSettings && pagination}
							// Filters
							filter={filterFactory()}
							// Row Events
							rowEvents= {rowEvents}
							{...props.baseProps}
						/>
					</div>
				}
			</ToolkitProvider >
		</div>
	}
}

export default Table



// WEBPACK FOOTER //
// ./src/components/Table.js